var injected = {
  user: null,
  source: null,
  FRONTEND_URL: null
};

export default injected;
//# sourceMappingURL=injected.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/injected.js
// module id = 36
// module chunks = 0